module.exports = __webpack_public_path__ + "img/AYT.c5005645.svg";